const NAME = "MY_GROUPS";

export default NAME;
